import { Link, Text } from '@cad-arc';
import React, { useRef, PropsWithChildren } from 'react';

interface Props {
    children: string;
    isDisabled: boolean;
    onClick: () => Promise<void>;
    color?: string;
}

export function FocusableLink({
    color = 'brand',
    children,
    isDisabled,
    onClick,
}: PropsWithChildren<Props>) {
    const linkRef = useRef<HTMLAnchorElement>(null);
    return isDisabled ? (
        <Text
            // @ts-expect-error color prop works
            color={color}
            as="span"
            style={{ opacity: 0.4, cursor: 'not-allowed' }}
        >
            {children}
        </Text>
    ) : (
        <Link
            // @ts-expect-error color prop works
            color={color}
            ref={linkRef}
            tabIndex={0}
            onClick={() => onClick()}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    // reclaim focus after link goes through disabled state
                    onClick().then(() =>
                        setTimeout(() => {
                            if (linkRef.current) {
                                linkRef.current.focus();
                            }
                        })
                    );
                }
            }}
        >
            {children}
        </Link>
    );
}
